import React from 'react';
import * as ReactDOM from 'react-dom';
import { Button, Modal, Toast, ListView, Icon, Carousel } from 'antd-mobile';
import moment from 'moment';

import {post} from '../../utils/request';
import { getUrlParam, href } from '../../utils/util';
import JsBridge from '../../utils/jsBridge'
import api from '../api';
import coupon from './img/coupon.png'
import cash from '../record/img/cash.png'
import fridge from '../record/img/fridge.png'
import ipad from '../record/img/ipad.png'
import washer from '../record/img/washer.png'
import './index.less';

function closest(el, selector) {
    const matchesSelector = el.matches || el.webkitMatchesSelector || el.mozMatchesSelector || el.msMatchesSelector;
    while (el) {
      if (matchesSelector.call(el, selector)) {
        return el;
      }
      el = el.parentElement;
    }
    return null;
  }

  var timer1 = null
  var timer2 = null
  var timer3 = null
  var timer4 = null

  class RowItem extends React.Component {
    render() {
      const { content, activedId, index } = this.props;
      return (
        <div className={activedId === content ? `br_item${index} active` : `br_item${index}`} id={`br_item_${content}`}>
        </div>
      )
    }
  }

class hundredDaysActivities extends React.Component {
    constructor(...args) {
        super(...args);

        this.state = {
            urlOps: {},
            data: [],
            skipCount: 0,
            pageSize: 10,
            listData: [],
            sharkNum: 0,
            activityCode: null,
            visible: false,
            activityEnable: true,
            successVisible: false,
            examVisible: false,
            todayVisible: false,
            noTimeVisible: false,
            shakeCode: null,
            winResult: {},
            // 九宫格内容list
            list: [1, 2, 3, 4, 5, 6, 7, 8],
            indexs: [1,2,3,4,5,6,7,8],
            // 被选中的格子的ID
            activedId: '',
            // 中奖ID
            prizeId: null,
            // 获得prizeId之后计算出的动画次数
            times: 0,
            // 当前动画次数
            actTimes: 0,
            // 是否正在抽奖
            isRolling: false,
            // 转盘速度
            speed: 100,
            prizeToCode: {}
        };
    }

    componentDidMount() {
        React.$hlInsight.track('Activity_PinanTwo_OpenActivity_Ck',{});
        window.scrollTo(0,0)
        window.didLogin = this.didLogin;
        
        var obj = '',obj1 = '',ops={};
        if(window.location.hash.indexOf('?') > -1 ){
            obj = window.location.hash.split('?')[1];
            obj1 = obj.split('&');
            for(var i=0;i<obj1.length;i++){
                ops[obj1[i].split('=')[0]] = obj1[i].split('=')[1] === 'undefined' ? '' : obj1[i].split('=')[1];
            }
            
            if(ops.app_stoken === 'null' || ops.app_stoken === '(null)' || ops.app_stoken === 'undefined' || !ops.app_stoken){
                // let viewPort = this.viewPort();
                // if (
                //     viewPort.ios ||
                //     viewPort.iPhone ||
                //     viewPort.iPad
                // ) {
                //     if(window.webkit){
                //         window.webkit.messageHandlers.login.postMessage('');
                //     }
                // } else {
                //     if(window.huilian){
                //         window.huilian.login('');
                //     }
                // }
                Toast.fail('您还未登录，请登录后再操作',999);
                return ;
            }
            this.getSharkNum(ops)
            this.setState({
                urlOps: ops
            },()=>{
            });
        }
    }

    getPrizeList = (ops) => {
        post({
            url: api.baiRiActivityLastUserPrizeList + '?app_stoken=' + ops.app_stoken + '&activity=365', 
            data: {
                pageSize: 50
            }
        }).then((res) => {
            if(res.result === 'success' && res.data.length>0){
                let newData = []
                for (let i = 0; i < res.data.length; i++) {
                    const element = res.data[i];
                    newData.push(`恭喜${element.phoneNumber} 抽中 ${element.prizeName}`)
                }
                console.log(newData)
                this.setState({ listData: newData })
            }else{
                // Toast.info(res.msg,1);
                console.log(res.msg)
            }
        }, (res)=>{
            Toast.info('获取信息失败',1);
        });
    }

    viewPort =  () => {
        let u = navigator.userAgent.toLowerCase();
        return {
            isWeixin: u.indexOf('micromessenger') > -1,
            isQQ: u.indexOf('qq/') > -1,
            trident: u.indexOf('trident') > -1, //IE内核
            presto: u.indexOf('presto') > -1, //opera内核
            webKit: u.indexOf('applewebkit') > -1, //苹果、谷歌内核
            gecko: u.indexOf('gecko') > -1 && u.indexOf('khtml') == -1, //火狐内核
            mobile:
                !!u.match(/applewebkit.*mobile.*/) ||
                !!u.match(/applewebkit/), //是否为移动终端
            ios: !!u.match(/\(i[^;]+;( u;)? cpu.+mac os x/), //ios终端
            android: u.indexOf('android') > -1 || u.indexOf('linux') > -1, //android终端或者uc浏览器
            iPhone: u.indexOf('iphone') > -1 || u.indexOf('mac') > -1, //是否为iPhone或者QQHD浏览器
            iPad: u.indexOf('ipad') > -1, //是否iPad
            webApp: u.indexOf('safari') == -1 //是a:否web应该程序，没有头部与底部
        };
    }

    appShare(ops){
        let viewPort = this.viewPort();
        post({
            url: api.selectBaiRiActivityDetail + '?app_stoken=' + ops.app_stoken + '&activity=365', 
            data: {
                activityCode: ops.activityCode
            }
        }).then((res) => {
            if(res.result === 'success' && res.data){
                const data = {
                    ...res.data,
                    shareImg: res.data.shareImg ? res.data.shareImg : ''
                }
                if (
                    viewPort.ios ||
                    viewPort.iPhone ||
                    viewPort.iPad
                ) {
                    if(window.webkit){
                        window.webkit.messageHandlers.showShare.postMessage({
                            title: data.shareTitle,
                            url: `${window.location.origin}${window.location.pathname}#/hundredDaysActivitiesShare`,
                            cotent: data.shareContent,
                            img: data.shareImg
                        });
                    }
                } else {
                    if(window.huilian){
                        window.huilian.showShareWeixin(`${window.location.origin}${window.location.pathname}#/hundredDaysActivitiesShare`, data.shareTitle, data.shareContent, data.shareImg);
                    }
                }
            }else{
                Toast.info(res.msg,1);
            }
        }, (res)=>{
            Toast.info('获取分享信息失败',1);
        });
    }

    didLogin(token){
        const { activityCode } = this.state
        window.location.href(window.location.origin+'/payment/#/hundredDaysActivities?app_stoken='+token+'&activityCode='+activityCode)
    }

    componentWillMount() {
        this.init()
    }

    init(){
        this.doShine()
        var obj = '',obj1 = '',ops={};
        if(window.location.hash.indexOf('?') > -1 ){
            obj = window.location.hash.split('?')[1];
            obj1 = obj.split('&');
            for(var i=0;i<obj1.length;i++){
                ops[obj1[i].split('=')[0]] = obj1[i].split('=')[1] === 'undefined' ? '' : obj1[i].split('=')[1];
            }
            this.setState({ activityCode: ops.activityCode })
            this.appShare(ops)
            this.getPrizeList(ops)
        }
        
    }
    
    doShine(){
    timer1 = setInterval(() => {
        document.querySelector('.br_border1').classList.remove('hidden')
        document.querySelector('.br_border2').classList.add('hidden')
    }, 1000);
    timer2 = setInterval(() => {
        document.querySelector('.br_border1').classList.add('hidden')
        document.querySelector('.br_border2').classList.remove('hidden')
    }, 2000);
    }
    handleBegin(code) {
        // this.state.isRolling为false的时候才能开始抽，不然会重复抽取，造成无法预知的后果
        if (!this.state.isRolling) {
          // 点击抽奖之后，我个人做法是将于九宫格有关的状态都还原默认
          this.setState({
            activedId: '',
            prizeId: null,
            times: 0,
            actTimes: 0,
            isRolling: true
          }, () => {
            // 状态还原之后才能开始真正的抽奖
            document.querySelector('.br_button').classList.add('move')
            setTimeout(() => {
                document.querySelector('.br_button').classList.remove('move')
            }, 300);
            this.handlePlay(code)
          })
        }
      }
    handlePlay(code) {
        clearInterval(timer1);
        clearInterval(timer2);
        timer3 = setInterval(() => {
            document.querySelector('.br_border1').classList.remove('hidden')
            document.querySelector('.br_border2').classList.add('hidden')
        }, 100);
        timer4 = setInterval(() => {
            document.querySelector('.br_border1').classList.add('hidden')
            document.querySelector('.br_border2').classList.remove('hidden')
        }, 200);
        // 奖项code映射
        const prizeToCode = {
            "olhs202301122111": 1,
            "jxoo202301126292": 2,
            "zmoo202301122325": 3,
            "hbdv202301121973": 4,
            "euer202301129602": 5,
            "oxlo202301123279": 6,
            "erza202301121037": 7,
            "ktgh202301123770": 8
        }
        let prize = prizeToCode[code]
        console.log(prize)
        this.setState({
          prizeToCode,
          prizeId: prize,
          activedId: 0
        })
        // 随机算出一个动画执行的最小次数，这里可以随机变更数值，按自己的需求来
        let times = this.state.list.length * Math.floor(Math.random() * 5 + 4)
        this.setState({
          times: times
        })
        // 抽奖正式开始↓↓
        this.begin = setInterval(() => {
          let num;
    
          if (this.state.activedId === this.state.prizeId && this.state.actTimes > this.state.times) {
            // 符合上述所有条件时才是中奖的时候，两个ID相同并且动画执行的次数大于(或等于也行)设定的最小次数
            clearInterval(this.begin)
            clearInterval(timer3)
            clearInterval(timer4)
            this.doShine()
            this.setState({
              isRolling: false
            })
            setTimeout(() => {
                this.setState({successVisible: true})
            }, 500);
            return
          }
    
          // 以下是动画执行时对id的判断
          if (this.state.activedId === '') {
            num = 0
            this.setState({
              activedId: num
            })
          } else {
            num = this.state.activedId
            if (num === 8) {
              num = 0
              this.setState({
                activedId: num
              })
            } else {
              num = num + 1
              this.setState({
                activedId: num
              })
            }
          }
    
          this.setState({
            actTimes: this.state.actTimes + 1
          })
    
        }, this.state.speed)
      }
    doShake(){
        const {urlOps} = this.state;
        if(urlOps.app_stoken === 'null' || urlOps.app_stoken === '(null)' || urlOps.app_stoken === 'undefined' || !urlOps.app_stoken){
            // let viewPort = this.viewPort();
            // if (
            //     viewPort.ios ||
            //     viewPort.iPhone ||
            //     viewPort.iPad
            // ) {
            //     if(window.webkit){
            //         window.webkit.messageHandlers.login.postMessage('');
            //     }
            // } else {
            //     if(window.huilian){
            //         window.huilian.login('');
            //     }
            // }
            Toast.fail('您还未登录，请登录后再操作',999);
            return;
        }
       
        post({
            url: api.baiRiLuckDraw + '?app_stoken=' + urlOps.app_stoken + '&activity=365',
            data:{
            }
          }).then((res) => {
              if(res.result == 'success' && res.data){
                this.getSharkNum(urlOps);
                if(res.data.prizeResultCode == 8){
                    this.setState({ failureVisible: true })
                } else if(res.data.prizeResultCode==4){
                    Toast.info('今日次数已用完！',3)
                } else if(res.data.prizeResultCode==5){
                   this.setState({ noTimeVisible: true })
                }
                if(res.data.prizeResultCode ===1){
                    this.handleBegin(res.data.winResult.activityPrizeCode)
                    this.setState({ winResult: res.data.winResult })
                } else if(res.data.prizeResultCode == 0) {
                    Toast.info('很遗憾，您未中奖！',3)
                }
                
              } else {
                // Toast.info(res.msg,10)
                console.log(res.msg)
              }
          }, (res)=>{
              console.log('查询失败', res)
          });
    }

    getSharkNum(ops){
        post({
            url: api.baiRiLuckDrawNum + '?app_stoken=' + ops.app_stoken + '&activity=365',
            data:{
            }
          }).then((res) => {
              if(res.result === 'success'){
                const {urlOps} = this.state
                this.setState({sharkNum: res.data})
            }else{
                // Toast.info(res.msg,10)
                console.log(res.msg)
              }
          }, (res)=>{
              console.log('查询失败', res)
          });
    }

    goToList = () => {
        const {urlOps} = this.state
        href(`hundredDaysRecords?app_stoken=${urlOps.app_stoken}&activityCode=${urlOps.activityCode}`); 
        clearInterval(timer1);
        clearInterval(timer2);
    }

    onWrapTouchStart = (e) => {
        // fix touch to scroll background page on iOS
        if (!/iPhone|iPod|iPad/i.test(navigator.userAgent)) {
          return;
        }
        const pNode = closest(e.target, '.am-modal-content');
        if (!pNode) {
          e.preventDefault();
        }
      }
    

    render() {
        const {data, urlOps, activityCode, sharkNum, visible, successVisible, winResult, todayVisible, noTimeVisible, activityResult, failureVisible,prizeId,list, activedId,indexs,listData} = this.state;

        return (
            <div className='br_bg'>
                <div className='main-bg'>
                    {listData.length>0?<div className='br_title'><div className='br_sound'></div>
                    <Carousel className="my-carousel"
                    style={{ top: '-0.26rem', marginLeft: '0.25rem'}}
                    vertical
                    dots={false}
                    dragging={false}
                    swiping={false}
                    autoplay
                    infinite
                    >
                    {
                        listData.map((item,index)=>(
                            <div key={item} className='v-item'>{item}</div>
                        ))
                    }
                    </Carousel>
                   </div>:''}
                </div>
                
                <div className='br_middle'>
                    <div className='br_border1 hidden'></div>
                    <div className='br_border2'></div>
                    <div ></div>
                    <RowItem content={list[0]} index={indexs[0]} activedId={activedId} />
                    <RowItem content={list[1]} index={indexs[1]} activedId={activedId} />
                    <RowItem content={list[2]} index={indexs[2]} activedId={activedId} />
                    <RowItem content={list[7]} index={indexs[3]} activedId={activedId} />
                    <div className='br_button_bg'>
                        <div className='br_button' onClick={() => this.doShake()}></div>
                    </div>
                    <RowItem content={list[3]} index={indexs[4]} activedId={activedId} />
                    <RowItem content={list[6]} index={indexs[5]} activedId={activedId} />
                    <RowItem content={list[5]} index={indexs[6]} activedId={activedId} />
                    <RowItem content={list[4]} index={indexs[7]} activedId={activedId} />
                </div>
                <p className='br_number'>我的抽奖机会：{sharkNum}次</p>
                
                <div style={{ position: 'fixed', right: 0, top: '1.3rem', zIndex: 20 }}>
                    <div className='record' onClick={()=>{this.goToList()}}></div>
                </div>
                 {/* <div style={{ position: 'fixed', right: 0, top: '1.3rem', zIndex: 20 }}>
                    <div className='record' onClick={()=>{this.setState({successVisible: true})}}></div>
                </div> */}

                <div className='br_activity' style={{ paddingTop: '0.18rem' }}>
                    <div className='activity-box'>
                            <div className='activity-logo'>
                                <div className='activity-logo-left'></div>
                                <div className='activity-logo-title'>活动说明</div>
                                <div className='activity-logo-right'></div>
                            </div>
                            <div className='br_content'>
                                <p>1、抽奖时间：2023年2月1日0：00-2023年2月7日23：59。</p>
                                <p>2、抽奖对象：2022年11月1日-2022年11月30日成功报名“百日挑战”的用户。</p>
                                <p>3、抽奖资质：于开奖日（2月1日）前100天内未出险或未产生违章则可获得1次抽奖机会，两者均未产生则获得2次抽奖机会，两者均产生则失去抽奖资质。</p>
                                <p>4、领奖方式：抽中华为matepad11、海尔272升冰箱、美的洗衣机等实物奖品的用户，客服将在7日内联系您前往现场领奖，由工作人员核对中奖信息后发放奖品；抽中100元、500元充电金的用户，奖品将在7个工作日内发放至您的充电卡账户内，前往我的-充电卡可查看充电金到账情况；抽中5元、10元、30元充电券的用户，奖品将在7个工作日内发放至您的账户内，前往我的-优惠券可查看到账情况。</p>
                                <p>5、本次活动最终解释权归主办方所有，与苹果（Apple Inc.）无关。</p>
                            </div>
                        </div>
                    </div>
                    <Modal className='br-proze-bg' transparent popup maskClosable={false} visible={successVisible} wrapProps={{ onTouchStart: this.onWrapTouchStart }}>
                    <div className='prize-content'>
                        <div className='prize-title'></div>
                        <div className='content-title'>{winResult.prizeName}</div>
                            <div className='content-img'><div style={{ width: '0.8rem', height: '0.8rem', backgroundImage: `url(${prizeId==1?ipad: prizeId==3?washer:prizeId==5?fridge:prizeId==6||prizeId==8?cash:coupon})`, backgroundRepeat: 'no-repeat', backgroundSize: '0.8rem 0.8rem',position: 'absolute', top: '0.86rem' }}></div></div>
                        <div style={{ fontSize:'0.12rem', marginLeft: '0.23rem', marginRight: '0.25rem', marginTop: '0.4rem', textAlign: 'left' }}>温馨提示：实物类奖品将在活动结束后7个工作日内由工作人员联系您前往领取；充电金、充电券将在7个工作日内发放至您的账号内。</div>
                        <Button className='prize-button' style={{ marginLeft: '0.5rem' }} onClick={()=>{this.setState({successVisible: false})}}>我知道了</Button>
                        <div style={{ width: '0.5rem', height: '0.5rem', margin: '0 auto' }} onClick={()=>{
                                this.setState({successVisible: false})
                            }}>
                            <Icon type='cross-circle' style={{ color: '#fff', display: 'block', width: '0.22rem', height: '0.22rem', position: 'absolute', left: '1.2rem', top: '3.5rem' }}></Icon>
                        </div>
                    </div>
                </Modal>
                <Modal className='br-proze-bg' transparent maskClosable={false} wrapProps={{ onTouchStart: this.onWrapTouchStart }} visible={todayVisible}>
                    <div className='notime-content'>
                        <div style={{ fontSize:'0.2rem', color: 'rgba(51, 51, 51, 1)', textAlign: 'center', marginTop: '0.42rem' }}>今日次数已用完，请明日再来哦</div>
                        <Button className='prize-button' style={{ marginTop: '0.3rem' }} onClick={()=>{
                            this.setState({todayVisible: false})
                        }}>我知道了</Button>
                        <div style={{ width: '0.5rem', height: '0.5rem', margin: '0 auto' }}  onClick={()=>{
                                this.setState({todayVisible: false})
                            }}>
                            <Icon type='cross-circle' style={{ color: '#fff', display: 'block', margin: '0.5rem auto',width: '0.22rem', height: '0.22rem' }}></Icon>
                        </div>
                    </div>
                </Modal>
                <Modal className='br-proze-bg' transparent maskClosable={false} wrapProps={{ onTouchStart: this.onWrapTouchStart }} visible={noTimeVisible}>
                    <div className='notime-content'>
                        <div style={{ fontSize:'0.2rem', color: 'rgba(51, 51, 51, 1)', textAlign: 'center', marginTop: '0.42rem' }}>很遗憾，次数已用完~</div>
                        <Button className='prize-button' style={{ marginTop: '0.3rem' }} onClick={()=>{
                            this.setState({noTimeVisible: false})
                            href(`peaceSharkIndex?app_stoken=${urlOps.app_stoken}`)
                        }}>去看看其他活动</Button>
                        <div style={{ width: '0.5rem', height: '0.5rem', margin: '0 auto' }} onClick={()=>{
                                this.setState({noTimeVisible: false})
                            }}>
                            <Icon type='cross-circle' style={{ color: '#fff', display: 'block', margin: '0.5rem auto',width: '0.22rem', height: '0.22rem', lineHeight: '0.22rem' }}></Icon>
                        </div>
                    </div>
                </Modal>

                {/* 百日行动 */}
                <Modal className='br-proze-bg' transparent popup maskClosable={false} visible={failureVisible} wrapProps={{ onTouchStart: this.onWrapTouchStart }}>
                    <div className='prize-content' style={{height:'2.1rem'}}>
                        {/* <div className='fail-title'></div> */}
                        <div className='content-title' style={{margin: '0.3rem 0.2rem 0.3rem',fontSize: '0.14rem'}}>很遗憾，暂无抽奖机会哦~</div>
                        <div style={{margin: '-0.2rem 0.3rem 0rem',fontSize: '0.14rem'}}>很抱歉，本次活动仅限已报名该活动且在100天内未出险或未产生违章的用户参与</div>
                        <Button className='prize-button' style={{ marginLeft: '0.5rem' }} onClick={()=>{
                            this.setState({failureVisible:false})
                             href(`peaceSharkIndex?app_stoken=${urlOps.app_stoken}`)
                        }}>去看看其他活动</Button>
                        <Icon type='cross-circle' style={{ color: '#fff', display: 'block', margin: '0.4rem auto' }} onClick={()=>{
                            this.setState({failureVisible: false})
                        }}></Icon>
                    </div>
                </Modal>
            </div>
        );
    }
}
export default hundredDaysActivities;


// WEBPACK FOOTER //
// ./src/hundredDaysActivities/index/index.js